import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const ConferenceVideos = () => {
  const location = useLocation();

  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const getConferenceIdFromUrl = () => {
    const pathParts = location.pathname.split("/").filter(Boolean);
    return pathParts[pathParts.length - 1];
  };

  const getYoutubeEmbedUrl = (url) => {
    if (!url) return "";

    if (url.includes("youtu.be/")) {
      const videoId = url.split("youtu.be/")[1]?.split("?")[0];
      return videoId ? `https://www.youtube.com/embed/${videoId}` : "";
    }

    if (url.includes("youtube.com/watch?v=")) {
      const videoId = url.split("v=")[1]?.split("&")[0];
      return videoId ? `https://www.youtube.com/embed/${videoId}` : "";
    }

    if (url.includes("youtube.com/embed/")) {
      return url;
    }

    return "";
  };

  useEffect(() => {
    const conferenceId = getConferenceIdFromUrl();

    if (!conferenceId) {
      setError("Conference ID not found in URL");
      setLoading(false);
      return;
    }

    const fetchConferenceVideos = async () => {
      try {
        setLoading(true);
        setError("");

        const res = await axios.get(
          `https://eventscons.com/eventbackendnew/api/conference-get-video-link/${conferenceId}`
        );

        const apiVideos = res?.data?.data?.conference_video_link || [];

        const normalizedVideos = Array.isArray(apiVideos)
          ? apiVideos.map((item) => getYoutubeEmbedUrl(item)).filter(Boolean)
          : [];

        setVideos(normalizedVideos.slice(0, 10));
      } catch (err) {
        console.error("Conference videos API error:", err);
        setError("Failed to load conference videos");
      } finally {
        setLoading(false);
      }
    };

    fetchConferenceVideos();
  }, [location.pathname]);

  return (
    <>
      <style>
        {`
          .conference-videos-section {
            max-width: 90%;
            margin: 40px auto;
          }

          .conference-videos-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 18px;
          }

          .conference-videos-header h2 {
            margin: 0;
            font-size: 20px;
            font-weight: 700;
            color: #111;
          }

          .divider {
            height: 1px;
            background: #cfcfcf;
            margin-bottom: 28px;
          }

          .conference-videos-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 20px 16px;
          }

          .conference-video-card {
            width: 100%;
            border-radius: 14px;
            overflow: hidden;
            border: 1.5px solid #a1264d;
            background: #000;
          }

          .conference-video-frame {
            width: 100%;
            height: 220px;
            display: block;
            border: none;
          }

          .status-text {
            text-align: center;
            font-size: 14px;
            color: #444;
            padding: 20px 0;
          }

          .error-text {
            color: red;
          }

          @media (max-width: 768px) {
            .conference-videos-grid {
              grid-template-columns: 1fr;
            }
          }

          @media (max-width: 480px) {
            .conference-video-frame {
              height: 190px;
            }
          }
        `}
      </style>

      <section className="conference-videos-section">
        <div className="conference-videos-header">
          <h2>VIDEOS</h2>
        </div>

        <div className="divider" />

        {loading ? (
          <p className="status-text">Loading videos...</p>
        ) : error ? (
          <p className="status-text error-text">{error}</p>
        ) : videos.length === 0 ? (
          <p className="status-text">No videos found.</p>
        ) : (
          <div className="conference-videos-grid">
            {videos.map((videoUrl, index) => (
              <div className="conference-video-card" key={index}>
                <iframe
                  className="conference-video-frame"
                  src={videoUrl}
                  title={`Conference Video ${index + 1}`}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            ))}
          </div>
        )}
      </section>
    </>
  );
};

export default ConferenceVideos;